import React, { useState } from 'react';
import ExportPDF from './ExportPDF';
import CustomModal from './CustomModal';
import swal from 'sweetalert2';

const Exporter = ({ missingSizesData, orderData }) => {
  const [pdfData, setPdfData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleExportMissingSizes = () => {
    const { missing_sizes } = missingSizesData;

    if (!missing_sizes || missing_sizes.length === 0) {
      swal.fire({
        title: 'Sin datos',
        text: 'No hay artículos pendientes de cargar talles.',
        icon: 'info',
        confirmButtonColor: "#0071ce"
      });
      return;
    }

    const expandedData = missing_sizes.flatMap(student =>
      student.items.flatMap(item =>
        Array.from({ length: item.pending }, (_, index) => ({
          name: student.name,
          itemName: item.name,
          itemAlias: item.alias,
          pending: `${index + 1} de ${item.pending}`
        }))
      )
    );

    setPdfData(expandedData);
    setShowModal(true);
  };

  return (
    <>
      <span onClick={handleExportMissingSizes}>
        Exportar Faltantes
      </span>
      {showModal && (
        <CustomModal onClose={() => setShowModal(false)}>
          <ExportPDF data={pdfData} orderData={orderData}/>
        </CustomModal>
      )}
    </>
  );
};

export default Exporter;